
import React, { useState, useCallback, useMemo, useRef } from 'react';
import { Popover } from 'devextreme-react/popover';
import './style-banner.css';
import { Button, ButtonTypes } from 'devextreme-react/button';
import { TextArea } from 'devextreme-react';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPopoverVisible: false
        };

        this.onOpenRichiesta = this.onOpenRichiesta.bind(this);
        this.showPopover = this.showPopover.bind(this);
        this.hidePopover = this.hidePopover.bind(this);
    }

    showPopover() {
        this.setState({
            isPopoverVisible: true
        });
    }

    hidePopover() {
        this.setState({
            isPopoverVisible: false
        });
    }

    render() {

        return (
            <div id="rcorners2" class="header">
                <p>Presente una richiesta creata nelle ultime 12 ore :
                    <a id="linkWarning" onClick={this.showPopover} href="javascript:void(0);"><font color="white"> Clicca qui per visualizzare</font></a>
                </p>
                <Popover
                    target="#linkWarning"
                    position="top"
                    title="DETTAGLIO RICHIESTA INTERVENTO"
                    showTitle={true}
                    showCloseButton={false}
                    width={550}
                    height={400}
                    shading={true}
                    visible={this.state.isPopoverVisible}
                    shadingColor="rgba(0, 0, 0, 0.5)"
                >
                    <TextArea text={this.props.text} className='textArea'>

                    </TextArea>

                    <div id="bottomButtons">
                        <div id="buttons">
                            <Button
                                id='APRI'
                                text="Apri e integra richiesta precedente"
                                type="default"
                                stylingMode="text"
                                onClick={this.onOpenRichiesta}
                            />
                            <Button
                                id='CHIUDI'
                                text="Annulla"
                                type="default"
                                stylingMode="text"
                                onClick={this.hidePopover}
                            />
                        </div>
                    </div>

                </Popover>

            </div>
        )
    }

    onOpenRichiesta = (e) => {
        this.props.onClick(e);
    };
}

export default App;